var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sheet" }, [
    _c("div", { staticClass: "sheetSet" }, [
      _vm._m(0),
      _c(
        "div",
        {
          staticClass: "sheetSetCen",
          staticStyle: { width: "260px", height: "200px", margin: "0 auto" },
        },
        [
          _c("examFace", {
            ref: "examFace",
            attrs: { isFaceVideo: _vm.isFaceVideo, dataText: _vm.dataText },
            on: { upCaptures: _vm.upCaptures },
          }),
        ],
        1
      ),
    ]),
    _vm.showTime
      ? _c("div", { staticClass: "settings" }, [
          _vm._m(1),
          _c("div", { staticClass: "sheetSetCen" }, [
            _c("div", { staticClass: "content" }, [
              _c("em"),
              _c("span", { staticClass: "mal30 mar20 black" }, [
                _vm._v("剩余时间:"),
              ]),
              _c("span", { staticClass: "f18 oringe" }, [
                _vm._v(_vm._s(_vm.endDate)),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
    _c("div", { staticClass: "topic" }, [
      _c("div", { staticClass: "title" }, [
        _c("i", { staticClass: "iconfont icondatiqia" }),
        _c("span", { staticClass: "active" }, [_vm._v("答题卡")]),
        _c("span", [_vm._v(_vm._s(_vm.done.length) + "/" + _vm._s(_vm.total))]),
      ]),
      _c(
        "div",
        { staticClass: "content" },
        _vm._l(_vm.datas, function (item, key) {
          return _c("div", { key: key, staticClass: "main" }, [
            _c("div", { staticClass: "header" }, [
              _c("em"),
              _c("span", [_vm._v(_vm._s(item.question_title))]),
              _c("span", [
                _vm._v(
                  "(共" +
                    _vm._s(item.list.length) +
                    "题,共" +
                    _vm._s(item.fraction) +
                    "分)"
                ),
              ]),
            ]),
            _c(
              "ul",
              _vm._l(item.list, function (item2, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    class:
                      _vm.isAnalysis || _vm.topicLx
                        ? _vm.toggleClass(item2.make_status)
                        : _vm.toggleClass(item2.is_make),
                    on: {
                      click: function ($event) {
                        return _vm.jump(item2.sort)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(item2.sort) + " ")]
                )
              }),
              0
            ),
          ])
        }),
        0
      ),
    ]),
    _c("div", { staticClass: "tagging" }, [
      _c(
        "ul",
        _vm._l(_vm.labelList, function (item, index) {
          return _c("li", { key: index }, [
            _c("em", { class: item.class }),
            _c("span", [_vm._v(_vm._s(item.name))]),
          ])
        }),
        0
      ),
      _c("div", { staticClass: "submit" }, [
        _c("div", { on: { click: _vm.submit } }, [
          _vm._v(_vm._s(_vm.isAnalysis ? "退出" : "提交")),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "title" }, [
      _c("i", { staticClass: "iconfont iconSettingscontroloptions" }),
      _vm._v("监考 "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "top" }, [
      _c("i", { staticClass: "iconfont iconnaozhong" }),
      _vm._v("倒计时 "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }